import { useLazyQuery } from '@apollo/client';
import { IQueryResult, IVariables } from './interfaces';
import { invoicesListQuery } from './gql';

export const useInvoicesListGql = () => {
  const [runInvoicesListGql, { loading, data, error }] = useLazyQuery<IQueryResult, IVariables>(invoicesListQuery, {
    context: {
      headers: {
        userFunctionKey: 'E4DA3B7FBBCE2345D7772B0674A318D5'
      }
    }
  });

  return {
    runInvoicesListGql,
    loadingInvoicesList: loading,
    cityHallSite: data?.ExtremaCityHallSite.cityHallSite || '',
    cityHallNfs: data?.ExtremaCityHallSite.cityHallNfs || '',
    dataInvoicesList: data?.InvoicesList || [],
    errorInvoicesList: error
  };
};
